import React from 'react';
import { observer } from 'mobx-react-lite';
import { Link1Icon, TrashIcon } from '@radix-ui/react-icons';
import { Switch } from '@producer/ui-kit';

import { DropdownMenu } from '../../../components/modals/dropdown-menu/DropdownMenu';
import { formatDate } from '../../../lib/utils/DateHelper';
import { dateShort } from '../../../assets/contants/dates-fns';
import { Asset } from '../../../app/entities/asset';

import type { ShareLink } from '../../../app/entities/share-link';

import styles from './share-link-item.module.scss';
type ShareLinkItemProps = {
  link: ShareLink;
};

export const ShareLinkItem: React.FC<ShareLinkItemProps> = observer(({ link }) => {
  const menuItems = [
    {
      onSelect: () => navigator.clipboard.writeText(link.url),
      title: 'Copy link',
      icon: <Link1Icon />,
    },
    {
      onSelect: () => link.delete(),
      title: 'Delete',
      icon: <TrashIcon />,
      type: 'danger' as const,
    },
  ];

  const hasDownloadableItems = link.assetIds
    .map((id) => Asset.getOne(id) || { type: 'file' })
    .some((asset) => asset!.type !== 'link');

  return (
    <tr className={styles['row']}>
      <td className={styles['cell']}>{link.name}</td>
      <td className={styles['cell']}>{formatDate(link.createdAt.toString(), dateShort)}</td>
      <td className={styles['cell']}>{link.assetIds?.length || 0}</td>
      <td className={styles['cell']}>{link.creatorName}</td>
      <td className={styles['cell']} style={{ textAlign: 'center' }}>
        {hasDownloadableItems && (
          <Switch
            onToggle={(canDownload) => link.update({ canDownload })}
            isToggled={!!link.settings.canDownload}
            size="medium"
          />
        )}
      </td>

      <td className={styles['cell']}>
        <DropdownMenu items={menuItems} />
      </td>
    </tr>
  );
});
